// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestDetails_container__tfPS0 {
  display: flex;
  flex-direction: column;

}

.RequestDetails_paper__7KQD0 {
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 10px 0px rgba(89, 124, 215, 0.25);
  background: linear-gradient(
    91deg,
    rgba(222, 248, 248, 0.32) 23.22%,
    rgba(222, 248, 248, 0) 99.28%
  );
  width: 100%;
  margin: 1rem;
  overflow: auto;
  max-width: 45rem;
}

.RequestDetails_backButton__v9SW0 {
  align-self: flex-start;
  padding: 0.2rem;
  border: 1px #5A9BD8 solid;
  color: #5A9BD8;
}

.RequestDetails_headingTopContainer__nOZxC {
    display: flex;
    justify-content: space-between; 
    flex-direction: row;
    margin-bottom: 8px;
    padding: 1rem;
    margin: 0;
    border-radius: 0.5rem;
    margin: 0.5rem 0 0 0;
    width: 91%;
    margin: 1rem;
    overflow: auto;
    max-width: 50rem;


  }
  
  .RequestDetails_headingContainer__1Qlb8{
    margin-top: 0.5rem; 
  }

  .RequestDetails_pageTitle__Fgvpg {
    flex-grow: 1;
    margin-left: 1rem;
    color: #5A9BD8;

  }

.RequestDetails_status__I9CFS {
    font-size: 0.9rem;
    border: 1px solid #428ace;
    border-radius: 0.5rem;
    background-color: #5A9BD8;
    padding: 0.1rem 0.5rem;
    align-self: flex-end;
    color: #000000;
}

.RequestDetails_requestDetailsContainer__pMtmu {
  padding: 1rem;
  margin: 0;
  border: 1px solid #5A9BD8;
  border-radius: 0.5rem;
  margin: 0.5rem 0 0 0;
  width: 91%;
  margin: 1rem;
  overflow: auto;
  max-width: 60rem;
  min-width: 10rem;
}

.RequestDetails_headingContainer__1Qlb8 {
  padding: 1rem;
  margin: 0;
  border: 1px solid #5A9BD8;
  border-radius: 0.5rem;
  margin: 0.5rem 0 0 0;
  width: 100%;
  margin: 1rem;
  overflow: auto;
  max-width: 50rem;
}


.RequestDetails_requesterLabel__ypQCI {
  margin-left: 1.2rem;
  text-align: left; 
  display: flex;
  text-align: left !important 
}

.RequestDetails_reviewDialogContainer__iKxPi {
  padding: 1rem;
  margin: 0;
  border-radius: 0.5rem;
  margin: 0.5rem 0 0 0;
  width: 100%;
  margin: 1rem;
  overflow: auto;
  max-width: 37rem;
}


.RequestDetails_bookingTitle__is9Ce {
}

.RequestDetails_subTitle__eW6Ez {
  font-size: 1rem;
  font-weight: 600;
}

.RequestDetails_listItem__4Sr06{
margin-top: 0.5rem;
}

.RequestDetails_formLabel__xO9Bv {
  margin-top: 50px;
  margin-bottom: 8px;
  padding-top: 10rem !important;
  font-weight: 600 !important;
  color: #0000009a;
}

.RequestDetails_formInput__iX5eX {
  margin-top: 10px;
}

.RequestDetails_form__\\+tF8n {
  display: flex;
  flex-direction: column;
}

.RequestDetails_commentTitle__NTHYU {
  font-weight: 600;
}

.RequestDetails_commentItem__XwMd8 {
  margin-bottom: 20px;
  color: #0000009a;
}

.RequestDetails_buttonContainer__Wavzi {
  margin-top: 2rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: flex-end !important;
}

.RequestDetails_closeButton__ZVfxw {
  padding: 0.2rem;
  border: 1px #5A9BD8 solid;
  color: #5A9BD8;
  position: 'absolute', 
}


.RequestDetails_contentContainerReq__hzmvk {
  display: flex;
  flex-direction: row;
  gap: 5rem;
  margin-top: 20px;
}

.RequestDetails_imageContainer__zmcoB {
  flex: 1 1; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.RequestDetails_detailsContainerReq__5ozAK {
  flex: 4 1;
}

.RequestDetails_avatarImage__ikof2 {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

@media (max-width: 770px) {
  .RequestDetails_container__tfPS0 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 1rem;
  }

  .RequestDetails_requestDetailsContainer__pMtmu,
  .RequestDetails_headingTopContainer__nOZxC {
    width: 90%;
    margin: 0;
    padding: 1rem;
    max-width: 90%;
  }

  .RequestDetails_headingTopContainer__nOZxC {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .RequestDetails_status__I9CFS {
    align-self: flex-start;
  }

  .RequestDetails_buttonContainer__Wavzi {
    justify-content: center;
    width: 100%;
  }

  .RequestDetails_reviewDialogContainer__iKxPi {
    width: 80%;
    max-width: 80%;
    margin: 0;
    padding: 1rem;
  }

  .RequestDetails_listItem__4Sr06 {
    margin-top: 0.5rem;
  }

  .RequestDetails_formLabel__xO9Bv {
    font-size: 0.9rem;
    margin-top: 0.5rem;
    margin-right: 10rem;

  }

  .RequestDetails_requesterLabel__ypQCI {
    margin-left: 0;
    margin-top: 0.5rem;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
  }

  .RequestDetails_paper__7KQD0 {
    width: 10%;
  }

}
`, "",{"version":3,"sources":["webpack://./src/Components/Shared/RequestDetails.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,qDAAqD;EACrD;;;;GAIC;EACD,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,oBAAoB;IACpB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,gBAAgB;;;EAGlB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,cAAc;;EAEhB;;AAEF;IACI,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;;AAGA;AACA;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,UAAU;IACV,SAAS;IACT,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,cAAc;IACd,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;;EAErB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;AAEF","sourcesContent":[".container {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n.paper {\r\n  padding: 2rem;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0px 4px 10px 0px rgba(89, 124, 215, 0.25);\r\n  background: linear-gradient(\r\n    91deg,\r\n    rgba(222, 248, 248, 0.32) 23.22%,\r\n    rgba(222, 248, 248, 0) 99.28%\r\n  );\r\n  width: 100%;\r\n  margin: 1rem;\r\n  overflow: auto;\r\n  max-width: 45rem;\r\n}\r\n\r\n.backButton {\r\n  align-self: flex-start;\r\n  padding: 0.2rem;\r\n  border: 1px #5A9BD8 solid;\r\n  color: #5A9BD8;\r\n}\r\n\r\n.headingTopContainer {\r\n    display: flex;\r\n    justify-content: space-between; \r\n    flex-direction: row;\r\n    margin-bottom: 8px;\r\n    padding: 1rem;\r\n    margin: 0;\r\n    border-radius: 0.5rem;\r\n    margin: 0.5rem 0 0 0;\r\n    width: 91%;\r\n    margin: 1rem;\r\n    overflow: auto;\r\n    max-width: 50rem;\r\n\r\n\r\n  }\r\n  \r\n  .headingContainer{\r\n    margin-top: 0.5rem; \r\n  }\r\n\r\n  .pageTitle {\r\n    flex-grow: 1;\r\n    margin-left: 1rem;\r\n    color: #5A9BD8;\r\n\r\n  }\r\n\r\n.status {\r\n    font-size: 0.9rem;\r\n    border: 1px solid #428ace;\r\n    border-radius: 0.5rem;\r\n    background-color: #5A9BD8;\r\n    padding: 0.1rem 0.5rem;\r\n    align-self: flex-end;\r\n    color: #000000;\r\n}\r\n\r\n.requestDetailsContainer {\r\n  padding: 1rem;\r\n  margin: 0;\r\n  border: 1px solid #5A9BD8;\r\n  border-radius: 0.5rem;\r\n  margin: 0.5rem 0 0 0;\r\n  width: 91%;\r\n  margin: 1rem;\r\n  overflow: auto;\r\n  max-width: 60rem;\r\n  min-width: 10rem;\r\n}\r\n\r\n.headingContainer {\r\n  padding: 1rem;\r\n  margin: 0;\r\n  border: 1px solid #5A9BD8;\r\n  border-radius: 0.5rem;\r\n  margin: 0.5rem 0 0 0;\r\n  width: 100%;\r\n  margin: 1rem;\r\n  overflow: auto;\r\n  max-width: 50rem;\r\n}\r\n\r\n\r\n.requesterLabel {\r\n  margin-left: 1.2rem;\r\n  text-align: left; \r\n  display: flex;\r\n  text-align: left !important \r\n}\r\n\r\n.reviewDialogContainer {\r\n  padding: 1rem;\r\n  margin: 0;\r\n  border-radius: 0.5rem;\r\n  margin: 0.5rem 0 0 0;\r\n  width: 100%;\r\n  margin: 1rem;\r\n  overflow: auto;\r\n  max-width: 37rem;\r\n}\r\n\r\n\r\n.bookingTitle {\r\n}\r\n\r\n.subTitle {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.listItem{\r\nmargin-top: 0.5rem;\r\n}\r\n\r\n.formLabel {\r\n  margin-top: 50px;\r\n  margin-bottom: 8px;\r\n  padding-top: 10rem !important;\r\n  font-weight: 600 !important;\r\n  color: #0000009a;\r\n}\r\n\r\n.formInput {\r\n  margin-top: 10px;\r\n}\r\n\r\n.form {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.commentTitle {\r\n  font-weight: 600;\r\n}\r\n\r\n.commentItem {\r\n  margin-bottom: 20px;\r\n  color: #0000009a;\r\n}\r\n\r\n.buttonContainer {\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.closeButton {\r\n  padding: 0.2rem;\r\n  border: 1px #5A9BD8 solid;\r\n  color: #5A9BD8;\r\n  position: 'absolute', \r\n}\r\n\r\n\r\n.contentContainerReq {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 5rem;\r\n  margin-top: 20px;\r\n}\r\n\r\n.imageContainer {\r\n  flex: 1; \r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.detailsContainerReq {\r\n  flex: 4;\r\n}\r\n\r\n.avatarImage {\r\n  width: 100px;\r\n  height: 100px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n@media (max-width: 770px) {\r\n  .container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .requestDetailsContainer,\r\n  .headingTopContainer {\r\n    width: 90%;\r\n    margin: 0;\r\n    padding: 1rem;\r\n    max-width: 90%;\r\n  }\r\n\r\n  .headingTopContainer {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .status {\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .buttonContainer {\r\n    justify-content: center;\r\n    width: 100%;\r\n  }\r\n\r\n  .reviewDialogContainer {\r\n    width: 80%;\r\n    max-width: 80%;\r\n    margin: 0;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .listItem {\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  .formLabel {\r\n    font-size: 0.9rem;\r\n    margin-top: 0.5rem;\r\n    margin-right: 10rem;\r\n\r\n  }\r\n\r\n  .requesterLabel {\r\n    margin-left: 0;\r\n    margin-top: 0.5rem;\r\n    text-align: center;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .paper {\r\n    width: 10%;\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RequestDetails_container__tfPS0`,
	"paper": `RequestDetails_paper__7KQD0`,
	"backButton": `RequestDetails_backButton__v9SW0`,
	"headingTopContainer": `RequestDetails_headingTopContainer__nOZxC`,
	"headingContainer": `RequestDetails_headingContainer__1Qlb8`,
	"pageTitle": `RequestDetails_pageTitle__Fgvpg`,
	"status": `RequestDetails_status__I9CFS`,
	"requestDetailsContainer": `RequestDetails_requestDetailsContainer__pMtmu`,
	"requesterLabel": `RequestDetails_requesterLabel__ypQCI`,
	"reviewDialogContainer": `RequestDetails_reviewDialogContainer__iKxPi`,
	"bookingTitle": `RequestDetails_bookingTitle__is9Ce`,
	"subTitle": `RequestDetails_subTitle__eW6Ez`,
	"listItem": `RequestDetails_listItem__4Sr06`,
	"formLabel": `RequestDetails_formLabel__xO9Bv`,
	"formInput": `RequestDetails_formInput__iX5eX`,
	"form": `RequestDetails_form__+tF8n`,
	"commentTitle": `RequestDetails_commentTitle__NTHYU`,
	"commentItem": `RequestDetails_commentItem__XwMd8`,
	"buttonContainer": `RequestDetails_buttonContainer__Wavzi`,
	"closeButton": `RequestDetails_closeButton__ZVfxw`,
	"contentContainerReq": `RequestDetails_contentContainerReq__hzmvk`,
	"imageContainer": `RequestDetails_imageContainer__zmcoB`,
	"detailsContainerReq": `RequestDetails_detailsContainerReq__5ozAK`,
	"avatarImage": `RequestDetails_avatarImage__ikof2`
};
export default ___CSS_LOADER_EXPORT___;
